/**
 * Flat nested maps for EN / MR / KN storefront copy. Keys use dot notation via ShopLanguageContext.t().
 */

const en = {
  header: {
    title: 'Ekdantarts - Handcrafted Ganesh Murty',
    titleShort: 'Ekdant Arts',
    subtitle: 'Handcrafted elegance for your celebrations',
    slogan: 'Devotion, Art & Tradition',
    trustLine: 'Trusted craftsmanship · Visit our Belagavi home workshop · Secure advance booking',
    devBanner:
      'This site is currently under development. Some features may evolve as we improve your experience.',
    brandCaption: 'EkDant Arts',
    logoAlt: 'EkDant Arts',
  },
  lang: {
    toggleAria: 'Choose language',
    enShort: 'EN',
    mrShort: 'मराठी',
    knShort: 'ಕನ್ನಡ',
  },
  nav: {
    wholesaleOrder: 'Wholesale order',
    wholesaleOrderShort: 'Wholesale',
    retailShop: 'Retail shop',
  },
  wholesaleBasket: {
    title: 'Wholesale basket order',
    subtitle: 'Select multiple models and quantities — minimum 14 total items to submit an inquiry.',
    selectModels: 'Select models',
    tapToAdd: 'Tap a model to add',
    inBucket: '{count} in basket',
    submit: 'Submit inquiry',
    emptyBucket: 'Add at least one model to your basket.',
    viewBucket: 'View basket',
    viewBucketShort: 'Basket',
    clear: 'Clear basket',
    cleared: 'Basket cleared',
    addedToBucket: 'Added to basket',
    updatedInBucket: 'Basket item updated',
    loading: 'Loading models…',
    retailLink: 'Ordering retail? Shop individual idols',
    minQtyCallout: 'Add 14+ total items across your basket to submit a wholesale inquiry.',
    wholesaleUnit: 'Wholesale',
    retailUnit: 'Retail',
    youSave: 'You save {amount} per piece',
    lineTotal: 'Total',
    stockLabel: 'Stock',
  },
  collage: {
    heading: 'Ekdantarts Ganapati Murthy Gallery',
    subheading:
      'A visual glimpse of the craftsmanship spirit before you explore the full idol gallery.',
    watermark: 'Ekdantarts Collage',
    labelSacredDetail: 'Sacred Detail',
    labelArtisanTouch: 'Artisan Touch',
    labelFestiveGlow: 'Festive Glow',
    labelGracefulForm: 'Graceful Form',
  },
  bookCta: {
    title: 'Ready to choose your idol?',
    subtitle: 'Click below to open the full model gallery and start booking.',
    bookIdol: 'Book Your Idol',
    collapseGallery: 'Collapse Gallery',
  },
  filters: {
    chooseSize: 'Choose Idol Size',
    chooseSizeShort: 'Size',
    all: 'All',
    categorySmall: 'Small',
    categorySmallShort: 'Small',
    categoryMedium: 'Medium',
    categoryMediumShort: 'Med',
    categoryLarge: 'Large',
    categoryLargeShort: 'Large',
    categoryPen: 'Pen/Artistic',
    categoryPenShort: 'Pen',
    sort: 'Sort',
    sortModelNumber: 'Model number (S→P order)',
    sortModelNumberShort: 'Model #',
    sortName: 'Name (A-Z)',
    sortNameShort: 'Name',
    sortPriceLow: 'Price (Low to High)',
    sortPriceLowShort: 'Price ↑',
    sortPriceHigh: 'Price (High to Low)',
    sortPriceHighShort: 'Price ↓',
    clearFilters: 'Clear Filters',
    clearFiltersShort: 'Clear',
    modelsCount: '{count} models',
    activeSizeAll: 'Showing: All models',
    activeSize: 'Showing: {label} ({range})',
    modelRangePrefix: 'M',
    wholesaleHint: 'Bulk basket — 14+ total items to submit inquiry',
    wholesaleBannerTitle: 'Bulk ordering?',
    wholesaleBannerHint: '14+ total items across any models — submit an inquiry and we confirm price on WhatsApp.',
  },
  cart: {
    itemsInCart_one: '{count} item in cart',
    itemsInCart_other: '{count} items in cart',
    total: 'Total:',
    viewCart: 'View Cart',
    collapse: 'Collapse',
    proceedCheckout: '🛒 Proceed to Checkout',
    proceedInquiry: '📝 Submit Inquiry',
    yourOrder_one: 'Your Order ({count} item)',
    yourOrder_other: 'Your Order ({count} items)',
    qtyShort: 'Qty:',
    removeItemTitle: 'Remove item',
    clearCart: 'Clear cart',
    clearCartConfirm: 'Remove all items from your cart?',
    checkoutSticky: 'Checkout',
    checkoutStickyInquiry: 'Submit Inquiry',
    wholesaleProgress: '{current} of {count} items — inquiry available at {count} total',
  },
  gallery: {
    featured: 'Featured Models',
    featuredBadge: 'Featured',
    modelPrefix: 'Model',
    allModels: 'All Models',
    stockLimited: 'Limited',
    stockReady: 'Ready',
    stockInStock: 'In stock · {count}',
    stockLow: 'Only {count} left',
    stockOutOfStock: 'Out of stock',
    outOfStockLocked: 'Out of stock',
    addToCartTitle: 'Add to Cart',
    retailOnlyBadge: 'Retail only',
    noMatchEmoji: 'No Match',
    noIdolsTitle: 'No Idols Found',
    noIdolsHint: 'Try adjusting your search or filter criteria.',
    clearAllFilters: 'Clear All Filters',
    catalogEmptyTitle: 'New Ganesh idol collection coming soon',
    catalogEmptyHint:
      'We are updating our handcrafted idols. Please check back shortly — thank you for your patience.',
    catalogEmptyThanks: 'Thank you for visiting EkDant Arts.',
    catalogUpdatingTitle: 'More idols are being added',
    catalogUpdatingHint:
      'Browse what’s available now — new designs are being added. Please check back soon for the full collection.',
    collapsedHint:
      'The model gallery is hidden. Open it with Book Your Idol to see every available idol.',
    wholesalePriceAtCheckout: 'Price confirmed after inquiry',
  },
  customerMode: {
    retail: 'Retail',
    wholesale: 'Wholesale',
    chooseTitle: 'Are you a retail or wholesale customer?',
    changeType: 'Change customer type',
    orderingAsRetail: 'Ordering as retail — single qty per model.',
    orderingAsWholesale: 'Bulk ordering — add 14+ total qty to submit a wholesale inquiry.',
    switchToWholesale: 'Switch to wholesale',
    switchToRetail: 'Switch to retail',
    retailHint: 'Single quantity per model — retail pricing.',
    wholesaleHint: 'Bulk quantities — submit inquiry; we confirm price on WhatsApp.',
    switchClearCartConfirm: 'Switching customer type will clear your cart. Continue?',
  },
  trustRow: {
    secureTitle: 'Secure Advance Checkout',
    secureBody: 'Safe Razorpay payment with instant receipt download.',
    inquiryTitle: 'Easy Order Inquiry',
    inquiryBody:
      'Submit your inquiry — we confirm after UPI advance via WhatsApp.',
    deliveryTitle: 'Visit Our Home Workshop',
    deliveryBody:
      'Kindly visit our home workshop to take home your Ganesh murti. Home delivery is not available. Address: House No. 283, Maruti Galli, Anagol, Belagavi-590006, Karnataka.',
    craftTitle: 'Handcrafted Assurance',
    craftBody: 'Each model is curated for festive quality and finishing.',
  },
  footer: {
    companyTitle: 'EkDant Arts',
    companyLead:
      'Traditional handcrafted Ganesh idols made with devotion and craftsmanship. Bringing ancient artistry to modern homes.',
    companyTagline:
      'Established with a passion for preserving cultural heritage through exquisite idol craftsmanship.',
    contactTitle: 'Contact Us',
    infoTitle: 'Information',
    adminLabel: 'Admin:',
    adminLogin: 'Admin Login',
    hoursLabel: 'Business Hours:',
    hoursBody: 'Monday - Saturday: 9:00 AM - 7:00 PM\nSunday: Closed',
    paymentLabel: 'Payment:',
    paymentBody: 'Cash, UPI, Bank Transfer',
    deliveryLabel: 'Workshop:',
    deliveryBody:
      'Visit our home workshop to take home your murti. Address: House No. 283, Maruti Galli, Anagol, Belagavi-590006, Karnataka',
    address: 'House No. 283, Maruti Galli, Anagol, Belagavi-590006, Karnataka',
    copyright: '© {year} EkDant Arts. All rights reserved.',
    craftedWith: 'Crafted with ❤️ for traditional artistry',
    systemTag: 'Ganesh Idol Booking & Management System',
  },
  orderModal: {
    orderPrefix: 'Order',
    quantity: 'Quantity *',
    total: 'Total:',
    customRequest: 'Custom Request',
    customPlaceholder: 'Any special requirements or customizations...',
    cartHintTitle: 'Customer details will be collected at checkout.',
    cartHintBody: 'You can add multiple items to your cart first.',
    addToCart: 'Add to Cart 🛒',
    stockLabel: 'Stock:',
    available: 'available',
    wholesaleMinQtyHint: 'Wholesale inquiries require at least 14 total items in your cart (any mix of models).',
  },
  checkoutModal: {
    title: 'Complete Your Order',
    summaryTitle: 'Order Summary',
    totalAmount: 'Total Amount:',
    customRequest: 'Special request / Color note (optional)',
    fullName: 'Full Name *',
    namePlaceholder: 'Enter your full name',
    phone: 'Phone Number *',
    phonePlaceholder: '10-digit mobile number',
    deliveryDate: 'Preferred take-home date',
    advanceLabel: 'Advance Payment Amount (₹) *',
    advanceHint:
      '💰 Minimum 40% of total order value required as advance payment',
    balanceDue: 'Balance due after advance:',
    paymentBlurb:
      "💳 Payment: You'll pay ₹{advance} now via Razorpay\n🏠 Take home: Balance payment when you take home the murti from our workshop",
    testPaymentHint:
      'Test mode: on desktop use Test Card (4111 1111 1111 1111) in Razorpay, or tap Simulate below. On mobile use UPI apps or scan QR.',
    simulateTestPayment: 'Simulate test payment & place order',
    proceedPayment: 'Proceed to Payment 💳',
    submitInquiry: 'Submit inquiry & notify on WhatsApp',
    inquiryBlurb:
      'Your inquiry is saved in our system. WhatsApp opens so you can message us. We confirm after UPI advance.',
    paymentDisabledHint:
      'Online payment is unavailable. Submit your inquiry — we will confirm after advance payment.',
    orderTypeRetail: 'Retail order',
    orderTypeWholesale: 'Wholesale order',
    retailOnlyWholesaleHint:
      'Your cart has 14+ items but includes retail-only models, so retail pricing applies.',
    wholesaleAdvanceHint:
      'Wholesale order: minimum 40% advance payment required at checkout.',
    wholesaleInquiryHint:
      'We will confirm pricing and advance payment on WhatsApp after reviewing your inquiry.',
  },
  whatsapp: {
    inquiryIntro: 'New shop inquiry {inquiryNo}',
    itemsHeader: 'Models:',
    footer: 'Submitted via Ekdantarts shop',
  },
  toast: {
    cartRestored: 'Your cart items are still here!',
    cartCleared: 'Cart cleared',
    loadCategoriesFailed: 'Failed to load categories',
    loadModelsFailed: 'Failed to load models',
    notEnoughStock: 'Not enough stock available',
    itemAdded: 'Item added to cart! 🛒',
    itemAlreadyInCart: 'This model is already in your cart',
    wholesaleMinQty: 'Wholesale checkout requires at least {count} total items in your cart (any mix of models).',
    wholesaleAddedNeedMore: 'Added to cart — add more models to reach {count} total items for wholesale checkout.',
    nameRequired: 'Customer name is required',
    phoneRequired: 'Valid 10-digit phone number required',
    advanceMin:
      'Advance payment must be at least ₹{amount} (40% of total order value)',
    advanceExceeds: 'Advance amount cannot exceed total order value',
    cartEmpty: 'No items in cart',
    advancePositive: 'Advance amount must be greater than ₹0 to proceed with payment',
    orderSuccessReceipt: '🎉 Order placed successfully! Receipt downloading...',
    needPdfReceipt: 'Need PDF instead?',
    downloadPdf: 'Download PDF',
    thankYou: 'Thank you for your order! We will contact you soon.',
    orderAfterPaymentFail:
      'Payment successful but order creation failed. Please contact support.',
    paymentCancelled: 'Payment cancelled by user',
    paymentFailed: 'Payment failed. Please try again.',
    paymentInitFailed: 'Failed to initialize payment. Please try again.',
    inquirySubmitted: 'Inquiry {inquiryNo} submitted! WhatsApp opened to notify us.',
    inquiryFailed: 'Failed to submit inquiry. Please try again.',
    wishlistRemoved: 'Removed from wishlist',
  },
  orderFlow: {
    verifying: 'Confirming your payment…',
    booking: 'Booking your Ganesh idol…',
    receipt: 'Preparing your receipt…',
    inquirySubmitting: 'Saving your inquiry…',
    inquirySuccessTitle: 'Your inquiry has been received',
    inquirySuccessSubtitle: 'Reference: {inquiryNo}',
    inquirySuccessBody:
      'Your request is saved in our system. We will confirm your order after UPI advance payment. You can optionally notify us on WhatsApp for faster follow-up.',
    openWhatsApp: 'Notify us on WhatsApp',
    bookedTitle: 'Your Ganesh Idol is booked successfully',
    bookedSubtitle: 'Order {orderNo} — receipt downloaded to your device',
    continueShopping: 'Continue shopping',
    downloadPdf: 'Download PDF receipt',
  },
  razorpay: {
    orgName: 'EkDant Arts',
    orderDescription: 'Order for {count} item',
    orderDescriptionPlural: 'Order for {count} items',
  },
  productDetail: {
    backToShop: '← Back to Shop',
    checkout: 'Checkout ({count})',
    viewGallery: 'View Gallery',
    craft: 'Craft',
    handmade: 'Handmade',
    delivery: 'Take home',
    panIndia: 'From workshop',
    payment: 'Payment',
    secure: 'Secure',
    inquiry: 'UPI Advance',
    stock: 'Stock:',
    available: 'available',
    outOfStock: 'Out of stock',
    outOfStockHint: 'This model is currently unavailable.',
    retailOnlyBadge: 'Retail only',
    category: 'Category:',
    defaultCategory: 'Ganesh Idol',
    whyTitle: 'Why customers choose this',
    why1: '• Premium handcrafted finish suitable for homes and events.',
    why2: '• Secure advance booking and reliable order confirmation.',
    why2Inquiry:
      '• Inquiry saved in our system — WhatsApp follow-up and UPI advance to confirm.',
    why3: '• Personalized custom request support before checkout.',
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    continueToCheckout: 'Continue to checkout',
    continueToInquiry: 'Continue to inquiry',
    continueShopping: 'Continue Shopping',
    wholesaleBasketLink: 'Build wholesale basket order',
    paymentCard: '40% advance with secure checkout',
    inquiryCard: '40% UPI advance to confirm after inquiry',
    paymentCardTitle: 'Payment',
    supportCard: 'Direct assistance for custom requests',
    supportCardTitle: 'Support',
    relatedModels: 'Related Models',
    testimonialsTitle: 'What families appreciate',
    testimonial1:
      '“The detailing and finish looked exactly like the photos. Booking process was smooth.”',
    testimonial2:
      '“Quick confirmation and transparent advance payment gave us confidence.”',
    testimonial3:
      '“Visiting the home workshop was simple, and we took home the murti in beautiful condition.”',
    loading: 'Loading model details...',
    modelNotFound: 'Model not found',
    loadDetailFailed: 'Failed to load model details',
    itemAdded: 'Item added to cart',
    orderPlaced: 'Order placed successfully',
    paymentCancelled: 'Payment cancelled',
    advanceAtLeast: 'Advance must be at least ₹{amount}',
    advanceExceedsTotal: 'Advance cannot exceed total amount',
    proceedPayment: 'Proceed to Payment',
    completeOrder: 'Complete Your Order',
    orderSummary: 'Order Summary',
    totalAmount: 'Total Amount:',
    verifyFailed: 'Payment verification failed',
  },
};

const mr = {
  header: {
    title: 'एकदंत आर्ट्स - हस्तनिर्मित गणेश मूर्ती',
    titleShort: 'एकदंत आर्ट्स',
    subtitle: 'आपल्या सणासाठी हस्तकला आणि सौंदर्य',
    slogan: 'भक्ती, कला आणि परंपरा',
    trustLine:
      'विश्वासार्ह कारागीरी · बेळगांव घरची कार्यशाळा · सुरक्षित आगाऊ बुकिंग',
    devBanner:
      'हे संकेतस्थळ सध्या विकासाधीन आहे. अनुभव सुधारताना काही वैशिष्ट्ये बदलू शकतात.',
    brandCaption: 'एकदंत आर्ट्स',
    logoAlt: 'एकदंत आर्ट्स',
  },
  lang: {
    toggleAria: 'भाषा निवडा',
    enShort: 'EN',
    mrShort: 'मराठी',
    knShort: 'ಕನ್ನಡ',
  },
  nav: {
    wholesaleOrder: 'घाऊक ऑर्डर',
    wholesaleOrderShort: 'घाऊक',
    retailShop: 'किरकोळ दुकान',
  },
  wholesaleBasket: {
    title: 'घाऊक बास्केट ऑर्डर',
    subtitle: 'अनेक मॉडेल आणि प्रमाण निवडा — चौकशी सबमिट करण्यासाठी किमान 14 एकूण.',
    selectModels: 'मॉडेल निवडा',
    tapToAdd: 'जोडण्यासाठी मॉडेलवर टॅप करा',
    inBucket: 'बास्केटमध्ये {count}',
    submit: 'चौकशी सबमिट करा',
    emptyBucket: 'बास्केटमध्ये किमान एक मॉडेल जोडा.',
    viewBucket: 'बास्केट पहा',
    viewBucketShort: 'बास्केट',
    clear: 'बास्केट रिकामा करा',
    cleared: 'बास्केट रिकामा',
    addedToBucket: 'बास्केटमध्ये जोडले',
    updatedInBucket: 'बास्केट आयटम अपडेट',
    loading: 'मॉडेल लोड होत आहेत…',
    retailLink: 'किरकोळ ऑर्डर? वैयक्तिक मूर्ती पहा',
    minQtyCallout: 'घाऊक चौकशीसाठी बास्केटमध्ये 14+ एकूण प्रमाण जोडा.',
    wholesaleUnit: 'घाऊक',
    retailUnit: 'किरकोळ',
    youSave: 'प्रति नग {amount} बचत',
    lineTotal: 'एकूण',
    stockLabel: 'स्टॉक',
  },
  collage: {
    heading: 'एकदंत आर्ट्स गणपती मूर्ती गॅलरी',
    subheading:
      'पूर्ण मूर्ती गॅलरी पाहण्यापूर्वी कारागीरीचा एक दृश्य अनुभव.',
    watermark: 'एकदंत कोलाज',
    labelSacredDetail: 'पावन सौंदर्य',
    labelArtisanTouch: 'कारागीर स्पर्श',
    labelFestiveGlow: 'सणाची चमक',
    labelGracefulForm: 'सौम्य रूप',
  },
  bookCta: {
    title: 'आपली मूर्ती निवडायला तयार?',
    subtitle:
      'संपूर्ण मॉडेल गॅलरी उघडण्यासाठी आणि बुकिंग सुरू करण्यासाठी खाली क्लिक करा.',
    bookIdol: 'आपली मूर्ती बुक करा',
    collapseGallery: 'गॅलरी संकुचित करा',
  },
  filters: {
    chooseSize: 'मूर्ती आकार निवडा',
    chooseSizeShort: 'आकार',
    all: 'सर्व',
    categorySmall: 'लहान',
    categorySmallShort: 'लहान',
    categoryMedium: 'मध्यम',
    categoryMediumShort: 'मध्यम',
    categoryLarge: 'मोठा',
    categoryLargeShort: 'मोठा',
    categoryPen: 'पेन/कलात्मक',
    categoryPenShort: 'पेन',
    sort: 'क्रमवारी',
    sortModelNumber: 'मॉडेल क्रमांक (S→P क्रम)',
    sortModelNumberShort: 'मॉडेल #',
    sortName: 'नाव (अ-य)',
    sortNameShort: 'नाव',
    sortPriceLow: 'किंमत (कमी ते जास्त)',
    sortPriceLowShort: 'किंमत ↑',
    sortPriceHigh: 'किंमत (जास्त ते कमी)',
    sortPriceHighShort: 'किंमत ↓',
    clearFilters: 'फिल्टर साफ करा',
    clearFiltersShort: 'साफ',
    modelsCount: '{count} मॉडेल्स',
    activeSizeAll: 'दर्शवित आहे: सर्व मॉडेल्स',
    activeSize: 'दर्शवित आहे: {label} ({range})',
    modelRangePrefix: 'M',
    wholesaleHint: 'घाऊक बास्केट — चौकशीसाठी 14+ एकूण प्रमाण',
    wholesaleBannerTitle: 'घाऊक ऑर्डर करत आहात?',
    wholesaleBannerHint: 'कोणत्याही मॉडेल्समध्ये 14+ एकूण प्रमाण — चौकशी सबमिट करा, किंमत WhatsApp वर पुष्टी करू.',
  },
  cart: {
    itemsInCart_one: 'कार्टमध्ये {count} आयटम',
    itemsInCart_other: 'कार्टमध्ये {count} आयटम्स',
    total: 'एकूण:',
    viewCart: 'कार्ट पाहा',
    collapse: 'संकुचित करा',
    proceedCheckout: '🛒 चेकआउट करा',
    proceedInquiry: '📝 चौकशी सबमिट करा',
    yourOrder_one: 'आपला ऑर्डर ({count} आयटम)',
    yourOrder_other: 'आपला ऑर्डर ({count} आयटम्स)',
    qtyShort: 'प्रमाण:',
    removeItemTitle: 'आयटम काढा',
    clearCart: 'कार्ट साफ करा',
    clearCartConfirm: 'कार्टमधील सर्व आयटम काढायचे?',
    checkoutSticky: 'चेकआउट',
    checkoutStickyInquiry: 'चौकशी सबमिट करा',
    wholesaleProgress: '{current} पैकी {count} — {count} एकूण झाल्यावर चौकशी',
  },
  gallery: {
    featured: 'वैशिष्ट्यपूर्ण मॉडेल्स',
    featuredBadge: 'वैशिष्ट्य',
    modelPrefix: 'मॉडेल',
    allModels: 'सर्व मॉडेल्स',
    stockLimited: 'मर्यादित',
    stockReady: 'तयार',
    stockInStock: 'साठा · {count}',
    stockLow: 'फक्त {count} शेष',
    stockOutOfStock: 'साठा संपला',
    outOfStockLocked: 'साठा संपला',
    addToCartTitle: 'कार्टमध्ये घाला',
    retailOnlyBadge: 'केवळ किरकोळ',
    noMatchEmoji: 'जुळले नाही',
    noIdolsTitle: 'मूर्ती सापडली नाहीत',
    noIdolsHint: 'शोध किंवा फिल्टर बदलून पुन्हा प्रयत्न करा.',
    clearAllFilters: 'सर्व फिल्टर साफ करा',
    catalogEmptyTitle: 'नवीन गणेश मूर्ती संग्रह लवकरच येत आहे',
    catalogEmptyHint:
      'आम्ही आमच्या हातमागच्या मूर्ती अद्ययावत करत आहोत. कृपया थोड्या वेळाने पुन्हा पाहा — आपल्या संयमाबद्दल धन्यवाद.',
    catalogEmptyThanks: 'एकदंत आर्ट्सला भेट दिल्याबद्दल धन्यवाद.',
    catalogUpdatingTitle: 'अधिक मूर्ती जोडल्या जात आहेत',
    catalogUpdatingHint:
      'सध्या उपलब्ध मूर्ती पहा — नवीन डिझाइन जोडले जात आहेत. पूर्ण संग्रहासाठी लवकरच पुन्हा भेट द्या.',
    collapsedHint:
      'मॉडेल गॅलरी दिसत नाही. सर्व उपलब्ध मूर्ती पाहण्यासाठी «आपली मूर्ती बुक करा» वापरा.',
    wholesalePriceAtCheckout: 'चौकशीनंतर किंमत पुष्टी',
  },
  customerMode: {
    retail: 'किरकोळ',
    wholesale: 'घाऊक',
    chooseTitle: 'तुम्ही किरकोळ की घाऊक ग्राहक आहात?',
    changeType: 'ग्राहक प्रकार बदला',
    orderingAsRetail: 'किरकोळ ऑर्डर — प्रति मॉडेल एकच प्रमाण.',
    orderingAsWholesale: 'घाऊक ऑर्डर — घाऊक चौकशीसाठी 14+ एकूण प्रमाण जोडा.',
    switchToWholesale: 'घाऊकवर स्विच करा',
    switchToRetail: 'किरकोळवर स्विच करा',
    retailHint: 'प्रति मॉडेल फक्त १ प्रमाण — किरकोळ किंमत.',
    wholesaleHint: 'मोठ्या प्रमाणात — चौकशी सबमिट करा; किंमत WhatsApp वर पुष्टी करू.',
    switchClearCartConfirm: 'ग्राहक प्रकार बदलल्यास कार्ट साफ होईल. पुढे जायचे?',
  },
  trustRow: {
    secureTitle: 'सुरक्षित आगाऊ चेकआउट',
    secureBody: 'Razorpay द्वारे सुरक्षित देयक आणि त्वरित पावती डाउनलोड.',
    inquiryTitle: 'सोपी ऑर्डर चौकशी',
    inquiryBody:
      'चौकशी सबमिट करा — UPI आगाऊ नंतर WhatsApp द्वारे पुष्टी.',
    deliveryTitle: 'आमच्या घरच्या कार्यशाळेला भेट द्या',
    deliveryBody:
      'कृपया आमच्या घरच्या कार्यशाळेत येऊन गणेश मूर्ती घरी न्या. घरपोहोच सेवा उपलब्ध नाही. पत्ता: घर नं. 283, मारुती गल्ली, अनगोळ, बेळगांव-590006, कर्नाटक.',
    craftTitle: 'हस्तनिर्मित खात्री',
    craftBody: 'प्रत्येक मॉडेल सणासाठी गुणवत्ता आणि फिनिशिंगसाठी निवडलेले.',
  },
  footer: {
    companyTitle: 'एकदंत आर्ट्स',
    companyLead:
      'भक्ती आणि कारागीरीने बनवलेल्या पारंपरिक गणेश मूर्ती. प्राचीन कलेचे आधुनिक घरात आणणे.',
    companyTagline:
      'उत्कृष्ट मूर्तीशिल्पासह सांस्कृतिक वारसा जपण्याच्या उत्साहाने स्थापन.',
    contactTitle: 'संपर्क',
    infoTitle: 'माहिती',
    adminLabel: 'अॅडमिन:',
    adminLogin: 'अॅडमिन लॉगिन',
    hoursLabel: 'व्यवसाय वेळ:',
    hoursBody: 'सोमवार - शनिवार: सकाळी ९ - संध्याकाळी ७\nरविवार: बंद',
    paymentLabel: 'देयक:',
    paymentBody: 'रोख, UPI, बँक हस्तांतरण',
    deliveryLabel: 'कार्यशाळा:',
    deliveryBody:
      'आमच्या घरच्या कार्यशाळेला भेट देऊन मूर्ती घरी न्या. पत्ता: घर नं. 283, मारुती गल्ली, अनगोळ, बेळगांव-590006, कर्नाटक',
    address: 'घर नं. 283, मारुती गल्ली, अनगोळ, बेळगांव-590006, कर्नाटक',
    copyright: '© {year} एकदंत आर्ट्स. सर्व हक्क राखीव.',
    craftedWith: 'पारंपरिक कलेसाठी ❤️ ने निर्मित',
    systemTag: 'गणेश मूर्ती बुकिंग आणि व्यवस्थापन प्रणाली',
  },
  orderModal: {
    orderPrefix: 'ऑर्डर',
    quantity: 'प्रमाण *',
    total: 'एकूण:',
    customRequest: 'खास विनंती',
    customPlaceholder: 'कोणतीही विशेष आवश्यकता किंवा सानुकूलन...',
    cartHintTitle: 'चेकआउट दरम्यान ग्राहक तपशील घेतले जातील.',
    cartHintBody: 'आधी कार्टमध्ये अनेक आयटम्स घालू शकता.',
    addToCart: 'कार्टमध्ये घाला 🛒',
    stockLabel: 'साठा:',
    available: 'उपलब्ध',
    wholesaleMinQtyHint: 'घाऊक चौकशीसाठी कार्टमध्ये किमान 14 एकूण प्रमाण (कोणत्याही मॉडेलच्या मिश्रणात) आवश्यक.',
  },
  checkoutModal: {
    title: 'आपला ऑर्डर पूर्ण करा',
    summaryTitle: 'ऑर्डर सारांश',
    totalAmount: 'एकूण रक्कम:',
    customRequest: 'विशेष विनंती / रंग नोट (ऐच्छिक)',
    fullName: 'पूर्ण नाव *',
    namePlaceholder: 'आपले पूर्ण नाव टाका',
    phone: 'फोन नंबर *',
    phonePlaceholder: '१० अंकी मोबाईल नंबर',
    deliveryDate: 'पसंतीची घरी नेण्याची तारीख',
    advanceLabel: 'आगाऊ देयक रक्कम (₹) *',
    advanceHint:
      '💰 एकूण मागणीच्या किमान ४०% आगाऊ देयक आवश्यक',
    balanceDue: 'आगाऊ नंतर शिल्लक:',
    paymentBlurb:
      '💳 देयक: आत्ता Razorpay द्वारे ₹{advance}\n🏠 घरी न्या: कार्यशाळेतून मूर्ती घरी नेताना शिल्लक देयक',
    testPaymentHint:
      'चाचणी मोड: डेस्कटॉपवर Razorpay मध्ये Test Card (4111 1111 1111 1111) वापरा, किंवा खाली Simulate दाबा. मोबाईलवर UPI अॅप किंवा QR.',
    simulateTestPayment: 'चाचणी देयक अनुकरण करा आणि ऑर्डर द्या',
    proceedPayment: 'देयकाकडे जा 💳',
    submitInquiry: 'चौकशी सबमिट करा आणि WhatsApp वर कळवा',
    inquiryBlurb:
      'तुमची चौकशी आमच्या सिस्टममध्ये जतन होते. WhatsApp उघडेल — UPI आगाऊ नंतर आम्ही पुष्टी करू.',
    paymentDisabledHint: 'ऑनलाइन देयक बंद आहे. चौकशी सबमिट करा — आगाऊ नंतर पुष्टी.',
    orderTypeRetail: 'किरकोळ ऑर्डर',
    orderTypeWholesale: 'घाऊक ऑर्डर',
    retailOnlyWholesaleHint:
      'तुमच्या कार्टमध्ये १४+ वस्तू आहेत पण किरकोळ-फक्त मॉडेल्स असल्याने किरकोळ दर लागू होतात.',
    wholesaleAdvanceHint:
      'घाऊक ऑर्डर: चेकआउटवर किमान ४०% आगाऊ आवश्यक.',
    wholesaleInquiryHint:
      'आपली चौकशी तपासल्यानंतर WhatsApp वर किंमत आणि आगाऊ देय पुष्टी करू.',
  },
  toast: {
    cartRestored: 'आपले कार्ट आयटम अजूनही आहेत!',
    cartCleared: 'कार्ट साफ केला',
    loadCategoriesFailed: 'श्रेणी लोड करता आली नाहीत',
    loadModelsFailed: 'मॉडेल्स लोड करता आले नाहीत',
    notEnoughStock: 'पुरेसा साठा नाही',
    itemAdded: 'आयटम कार्टमध्ये घातला! 🛒',
    itemAlreadyInCart: 'हे मॉडेल आधीच कार्टमध्ये आहे',
    wholesaleMinQty: 'घाऊक चेकआउटसाठी कार्टमध्ये किमान {count} एकूण प्रमाण (कोणत्याही मॉडेलच्या मिश्रणात) आवश्यक.',
    wholesaleAddedNeedMore: 'कार्टमध्ये जोडले — घाऊक चेकआउटसाठी {count} एकूण प्रमाण पूर्ण करण्यासाठी अजून मॉडेल जोडा.',
    nameRequired: 'ग्राहकाचे नाव आवश्यक आहे',
    phoneRequired: 'वैध १० अंकी फोन नंबर आवश्यक',
    advanceMin: 'आगाऊ देय किमान ₹{amount} असावे (एकूण मागणीच्या ४०%)',
    advanceExceeds: 'आगाऊ रक्कम एकूण मागणीपेक्षा जास्त असू शकत नाही',
    cartEmpty: 'कार्ट रिकामी आहे',
    advancePositive: 'देय सुरू करण्यासाठी आगाऊ रक्कम ₹० पेक्षा जास्त असावी',
    orderSuccessReceipt:
      '🎉 ऑर्डर यशस्वी! पावती डाउनलोड होत आहे...',
    needPdfReceipt: 'PDF हवे आहे?',
    downloadPdf: 'PDF डाउनलोड',
    thankYou: 'आपल्या ऑर्डरबद्दल धन्यवाद! लवकरच संपर्क करू.',
    orderAfterPaymentFail:
      'देयक यशस्वी पण ऑर्डर तयार करता आला नाही. सपोर्टशी संपर्क करा.',
    paymentCancelled: 'देयक वापरकर्त्याने रद्द केले',
    paymentFailed: 'देयक अयशस्वी. पुन्हा प्रयत्न करा.',
    paymentInitFailed: 'देयक सुरू करता आले नाही. पुन्हा प्रयत्न करा.',
    wishlistRemoved: 'इच्छा यादीतून काढले',
  },
  orderFlow: {
    verifying: 'आपले देयक पुष्टी करत आहोत…',
    booking: 'आपला गणेश मूर्ती बुक करत आहोत…',
    receipt: 'आपली पावती तयार करत आहोत…',
    inquirySubmitting: 'आपली चौकशी जतन करत आहोत…',
    inquirySuccessTitle: 'आपली चौकशी मिळाली',
    inquirySuccessSubtitle: 'संदर्भ: {inquiryNo}',
    inquirySuccessBody:
      'आपली विनंती आमच्या सिस्टममध्ये जतन झाली. UPI आगाऊ नंतर आम्ही ऑर्डर पुष्टी करू. जलद फॉलो-अपसाठी WhatsApp वर कळवू शकता.',
    openWhatsApp: 'WhatsApp वर कळवा',
    bookedTitle: 'आपली गणेश मूर्ती यशस्वीरित्या बुक झाली',
    bookedSubtitle: 'ऑर्डर {orderNo} — पावती आपल्या डिव्हाइसवर डाउनलोड झाली',
    continueShopping: 'खरेदी सुरू ठेवा',
    downloadPdf: 'PDF पावती डाउनलोड करा',
  },
  razorpay: {
    orgName: 'एकदंत आर्ट्स',
    orderDescription: '{count} आयटमसाठी ऑर्डर',
    orderDescriptionPlural: '{count} आयटम्ससाठी ऑर्डर',
  },
  productDetail: {
    backToShop: '← दुकानात परत',
    checkout: 'चेकआउट ({count})',
    viewGallery: 'गॅलरी पाहा',
    craft: 'कारागीरी',
    handmade: 'हस्तनिर्मित',
    delivery: 'घरी न्या',
    panIndia: 'कार्यशाळेतून',
    payment: 'देयक',
    secure: 'सुरक्षित',
    inquiry: 'UPI आगाऊ',
    stock: 'साठा:',
    available: 'उपलब्ध',
    outOfStock: 'साठा संपला',
    outOfStockHint: 'हे मॉडेल सध्या उपलब्ध नाही.',
    retailOnlyBadge: 'केवळ किरकोळ',
    category: 'श्रेणी:',
    defaultCategory: 'गणेश मूर्ती',
    whyTitle: 'ग्राहक का निवडतात',
    why1: '• घर आणि कार्यक्रमांसाठी प्रीमियम हस्तनिर्मित फिनिश.',
    why2: '• सुरक्षित आगाऊ बुकिंग आणि विश्वासार्ह पुष्टीकरण.',
    why2Inquiry:
      '• चौकशी सिस्टममध्ये जतन — WhatsApp आणि UPI आगाऊ नंतर पुष्टी.',
    why3: '• चेकआउटपूर्वी वैयक्तिक खास विनंती समर्थन.',
    addToCart: 'कार्टमध्ये घाला',
    buyNow: 'आत्ता खरेदी करा',
    continueToCheckout: 'चेकआउटकडे जा',
    continueToInquiry: 'चौकशीकडे जा',
    continueShopping: 'खरेदी सुरू ठेवा',
    wholesaleBasketLink: 'घाऊक बास्केट ऑर्डर तयार करा',
    paymentCard: 'सुरक्षित चेकआउटसह ४०% आगाऊ',
    inquiryCard: 'चौकशीनंतर UPI आगाऊने ४०% पुष्टी',
    paymentCardTitle: 'देयक',
    supportCard: 'खास विनंत्या साठी थेट मदत',
    supportCardTitle: 'मदत',
    relatedModels: 'संबंधित मॉडेल्स',
    testimonialsTitle: 'कुटुंबांना काय आवडते',
    testimonial1:
      '“सूक्ष्मता आणि फिनिश फोटोंप्रमाणेच होती. बुकिंग सोपी होती.”',
    testimonial2:
      '“त्वरित पुष्टीकरण आणि पारदर्शक आगाऊ देयकाने विश्वास वाढला.”',
    testimonial3:
      '“घरच्या कार्यशाळेला भेट देणे सोपे होते आणि मूर्ती उत्तम स्थितीत घरी नेली.”',
    loading: 'मॉडेल तपशील लोड होत आहेत...',
    modelNotFound: 'मॉडेल सापडले नाही',
    loadDetailFailed: 'मॉडेल तपशील लोड करता आले नाहीत',
    itemAdded: 'आयटम कार्टमध्ये घातला',
    orderPlaced: 'ऑर्डर यशस्वी',
    paymentCancelled: 'देयक रद्द',
    advanceAtLeast: 'आगाऊ किमान ₹{amount} असावी',
    advanceExceedsTotal: 'आगाऊ एकूण रकमेपेक्षा जास्त असू शकत नाही',
    proceedPayment: 'देयकाकडे जा',
    completeOrder: 'आपला ऑर्डर पूर्ण करा',
    orderSummary: 'ऑर्डर सारांश',
    totalAmount: 'एकूण रक्कम:',
    verifyFailed: 'देयक पडताळणी अयशस्वी',
  },
};

const kn = {
  header: {
    title: 'ಏಕದಂತ ಆರ್ಟ್ಸ್ - ಕೈಯಿಂದ ತಯಾರಿಸಿದ ಗಣೇಶ ಮೂರ್ತಿ',
    titleShort: 'ಏಕದಂತ ಆರ್ಟ್ಸ್',
    subtitle: 'ನಿಮ್ಮ ಹಬ್ಬಗಳಿಗೆ ಕೈಯಿಂದ ತಯಾರಿಸಿದ ಸೌಂದರ್ಯ',
    slogan: 'ಭಕ್ತಿ, ಕಲೆ ಮತ್ತು ಪರಂಪರೆ',
    trustLine:
      'ವಿಶ್ವಾಸಾರ್ಹ ಕುಶಲತೆ · ಬೆಳಗಾವಿ ಮನೆಯ ಕಾರ್ಯಾಗಾರ · ಸುರಕ್ಷಿತ ಅಡ್ವಾನ್ಸ್ ಬುಕಿಂಗ್',
    devBanner:
      'ಈ ಸೈಟ್ ಪ್ರಸ್ತುತ ಅಭಿವೃದ್ಧಿಯಲ್ಲಿದೆ. ಅನುಭವವನ್ನು ಸುಧಾರಿಸುವಾಗ ಕೆಲವು ವೈಶಿಷ್ಟ್ಯಗಳು ಬದಲಾಗಬಹುದು.',
    brandCaption: 'ಏಕದಂತ ಆರ್ಟ್ಸ್',
    logoAlt: 'ಏಕದಂತ ಆರ್ಟ್ಸ್',
  },
  lang: {
    toggleAria: 'ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ',
    enShort: 'EN',
    mrShort: 'मराठी',
    knShort: 'ಕನ್ನಡ',
  },
  nav: {
    wholesaleOrder: 'ಸಗಟು ಆರ್ಡರ್',
    wholesaleOrderShort: 'ಸಗಟು',
    retailShop: 'ಚಿಲ್ಲರೆ ಅಂಗಡಿ',
  },
  wholesaleBasket: {
    title: 'ಸಗಟು ಬುಕೆಟ್ ಆರ್ಡರ್',
    subtitle: 'ಅನೇಕ ಮಾದರಿಗಳು ಮತ್ತು ಪ್ರಮಾಣ ಆಯ್ಕೆಮಾಡಿ — ವಿನಂತಿ ಸಲ್ಲಿಸಲು ಕನಿಷ್ಠ 14 ಒಟ್ಟು.',
    selectModels: 'ಮಾದರಿಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    tapToAdd: 'ಸೇರಿಸಲು ಮಾದರಿಯ ಮೇಲೆ ಟ್ಯಾಪ್ ಮಾಡಿ',
    inBucket: 'ಬುಕೆಟ್‌ನಲ್ಲಿ {count}',
    submit: 'ವಿನಂತಿ ಸಲ್ಲಿಸಿ',
    emptyBucket: 'ಬುಕೆಟ್‌ಗೆ ಕನಿಷ್ಠ ಒಂದು ಮಾದರಿ ಸೇರಿಸಿ.',
    viewBucket: 'ಬುಕೆಟ್ ನೋಡಿ',
    viewBucketShort: 'ಬುಕೆಟ್',
    clear: 'ಬುಕೆಟ್ ತೆರವುಗೊಳಿಸಿ',
    cleared: 'ಬುಕೆಟ್ ತೆರವಾಗಿದೆ',
    addedToBucket: 'ಬುಕೆಟ್‌ಗೆ ಸೇರಿಸಲಾಗಿದೆ',
    updatedInBucket: 'ಬುಕೆಟ್ ಐಟಂ ನವೀಕರಿಸಲಾಗಿದೆ',
    loading: 'ಮಾದರಿಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ…',
    retailLink: 'ಚಿಲ್ಲರೆ ಆರ್ಡರ್? ವೈಯಕ್ತಿಕ ಮೂರ್ತಿಗಳನ್ನು ನೋಡಿ',
    minQtyCallout: 'ಸಗಟು ವಿನಂತಿಗೆ ಬುಕೆಟ್‌ನಲ್ಲಿ 14+ ಒಟ್ಟು ಪ್ರಮಾಣ ಸೇರಿಸಿ.',
    wholesaleUnit: 'ಸಗಟು',
    retailUnit: 'ಚಿಲ್ಲರೆ',
    youSave: 'ಪ್ರತಿ ತುಂಡಿಗೆ {amount} ಉಳಿತಾಯ',
    lineTotal: 'ಒಟ್ಟು',
    stockLabel: 'ಸ್ಟಾಕ್',
  },
  collage: {
    heading: 'ಏಕದಂತ ಆರ್ಟ್ಸ್ ಗಣಪತಿ ಮೂರ್ತಿ ಗ್ಯಾಲರಿ',
    subheading:
      'ಪೂರ್ಣ ಮೂರ್ತಿ ಗ್ಯಾಲರಿಯನ್ನು ಅನ್ವೇಷಿಸುವ ಮೊದಲು ಕುಶಲತೆಯ ಆತ್ಮದ ದೃಶ್ಯ.',
    watermark: 'ಏಕದಂತ ಕೊಲಾಜ್',
    labelSacredDetail: 'ಪವಿತ್ರ ವಿವರ',
    labelArtisanTouch: 'ಕುಶಲಕರರ ಸ್ಪರ್ಶ',
    labelFestiveGlow: 'ಹಬ್ಬದ ಪ್ರಕಾಶ',
    labelGracefulForm: 'ಸೌಮ್ಯ ರೂಪ',
  },
  bookCta: {
    title: 'ನಿಮ್ಮ ಮೂರ್ತಿಯನ್ನು ಆಯ್ಕೆ ಮಾಡಲು ಸಿದ್ಧರಿದ್ದೀರಾ?',
    subtitle:
      'ಪೂರ್ಣ ಮಾದರಿ ಗ್ಯಾಲರಿಯನ್ನು ತೆರೆಯಲು ಮತ್ತು ಬುಕಿಂಗ್ ಪ್ರಾರಂಭಿಸಲು ಕೆಳಗೆ ಕ್ಲಿಕ್ ಮಾಡಿ.',
    bookIdol: 'ನಿಮ್ಮ ಮೂರ್ತಿಯನ್ನು ಕಾಯ್ದಿರಿಸಿ',
    collapseGallery: 'ಗ್ಯಾಲರಿ ಸಂಕುಚಿಸಿ',
  },
  filters: {
    chooseSize: 'ಮೂರ್ತಿ ಗಾತ್ರ ಆಯ್ಕೆಮಾಡಿ',
    chooseSizeShort: 'ಗಾತ್ರ',
    all: 'ಎಲ್ಲಾ',
    categorySmall: 'ಚಿಕ್ಕ',
    categorySmallShort: 'ಚಿಕ್ಕ',
    categoryMedium: 'ಮಧ್ಯಮ',
    categoryMediumShort: 'ಮಧ್ಯ',
    categoryLarge: 'ದೊಡ್ಡ',
    categoryLargeShort: 'ದೊಡ್ಡ',
    categoryPen: 'ಪೆನ್/ಕಲಾತ್ಮಕ',
    categoryPenShort: 'ಪೆನ್',
    sort: 'ವಿಂಗಡಿಸಿ',
    sortModelNumber: 'ಮಾದರಿ ಸಂಖ್ಯೆ (S→P ಕ್ರಮ)',
    sortModelNumberShort: 'ಮಾದರಿ #',
    sortName: 'ಹೆಸರು (ಅ-ಹ)',
    sortNameShort: 'ಹೆಸರು',
    sortPriceLow: 'ಬೆಲೆ (ಕಡಿಮೆ ನಿಂದ ಹೆಚ್ಚು)',
    sortPriceLowShort: 'ಬೆಲೆ ↑',
    sortPriceHigh: 'ಬೆಲೆ (ಹೆಚ್ಚು ನಿಂದ ಕಡಿಮೆ)',
    sortPriceHighShort: 'ಬೆಲೆ ↓',
    clearFilters: 'ಫಿಲ್ಟರ್‌ಗಳನ್ನು ತೆರವುಗೊಳಿಸಿ',
    clearFiltersShort: 'ತೆರವು',
    modelsCount: '{count} ಮಾದರಿಗಳು',
    activeSizeAll: 'ತೋರಿಸುತ್ತಿದೆ: ಎಲ್ಲಾ ಮಾದರಿಗಳು',
    activeSize: 'ತೋರಿಸುತ್ತಿದೆ: {label} ({range})',
    modelRangePrefix: 'M',
    wholesaleHint: 'ಸಗಟು ಬುಕೆಟ್ — ವಿನಂತಿ ಸಲ್ಲಿಸಲು 14+ ಒಟ್ಟು ಪ್ರಮಾಣ',
    wholesaleBannerTitle: 'ಸಗಟು ಆರ್ಡರ್ ಮಾಡುತ್ತಿದ್ದೀರಾ?',
    wholesaleBannerHint: 'ಯಾವುದೇ ಮಾದರಿಗಳಲ್ಲಿ 14+ ಒಟ್ಟು ಪ್ರಮಾಣ — ವಿನಂತಿ ಸಲ್ಲಿಸಿ, WhatsApp ನಲ್ಲಿ ಬೆಲೆ ದೃಢೀಕರಿಸುತ್ತೇವೆ.',
  },
  cart: {
    itemsInCart_one: 'ಕಾರ್ಟ್‌ನಲ್ಲಿ {count} ವಸ್ತು',
    itemsInCart_other: 'ಕಾರ್ಟ್‌ನಲ್ಲಿ {count} ವಸ್ತುಗಳು',
    total: 'ಒಟ್ಟು:',
    viewCart: 'ಕಾರ್ಟ್ ನೋಡಿ',
    collapse: 'ಸಂಕುಚಿಸಿ',
    proceedCheckout: '🛒 ಚೆಕ್‌ಔಟ್ ಮಾಡಿ',
    proceedInquiry: '📝 ವಿನಂತಿ ಸಲ್ಲಿಸಿ',
    yourOrder_one: 'ನಿಮ್ಮ ಆರ್ಡರ್ ({count} ವಸ್ತು)',
    yourOrder_other: 'ನಿಮ್ಮ ಆರ್ಡರ್ ({count} ವಸ್ತುಗಳು)',
    qtyShort: 'ಪ್ರಮಾಣ:',
    removeItemTitle: 'ವಸ್ತು ತೆಗೆದುಹಾಕಿ',
    clearCart: 'ಕಾರ್ಟ್ ತೆರವುಗೊಳಿಸಿ',
    clearCartConfirm: 'ನಿಮ್ಮ ಕಾರ್ಟ್‌ನಿಂದ ಎಲ್ಲಾ ವಸ್ತುಗಳನ್ನು ತೆಗೆದುಹಾಕುವುದೇ?',
    checkoutSticky: 'ಚೆಕ್‌ಔಟ್',
    checkoutStickyInquiry: 'ವಿನಂತಿ ಸಲ್ಲಿಸಿ',
    wholesaleProgress: '{count} ರಲ್ಲಿ {current} — {count} ಒಟ್ಟು ಪ್ರಮಾಣದಲ್ಲಿ ವಿನಂತಿ',
  },
  gallery: {
    featured: 'ವಿಶೇಷ ಮಾದರಿಗಳು',
    featuredBadge: 'ವಿಶೇಷ',
    modelPrefix: 'ಮಾದರಿ',
    allModels: 'ಎಲ್ಲಾ ಮಾದರಿಗಳು',
    stockLimited: 'ಸೀಮಿತ',
    stockReady: 'ಸಿದ್ಧ',
    stockInStock: 'ಸ್ಟಾಕ್ · {count}',
    stockLow: 'ಕೇವಲ {count} ಬಾಕಿ',
    stockOutOfStock: 'ಸ್ಟಾಕ್ ಇಲ್ಲ',
    outOfStockLocked: 'ಸ್ಟಾಕ್ ಇಲ್ಲ',
    addToCartTitle: 'ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಿ',
    retailOnlyBadge: 'ಚಿಲ್ಲರೆ ಮಾತ್ರ',
    noMatchEmoji: 'ಹೊಂದಿಕೆಯಿಲ್ಲ',
    noIdolsTitle: 'ಮೂರ್ತಿಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
    noIdolsHint: 'ನಿಮ್ಮ ಹುಡುಕಾಟ ಅಥವಾ ಫಿಲ್ಟರ್ ಮಾನದಂಡಗಳನ್ನು ಸರಿಹೊಂದಿಸಿ.',
    clearAllFilters: 'ಎಲ್ಲಾ ಫಿಲ್ಟರ್‌ಗಳನ್ನು ತೆರವುಗೊಳಿಸಿ',
    catalogEmptyTitle: 'ಹೊಸ ಗಣೇಶ ಮೂರ್ತಿ ಸಂಗ್ರಹ ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ',
    catalogEmptyHint:
      'ನಾವು ನಮ್ಮ ಕರಕುಶಲ ಮೂರ್ತಿಗಳನ್ನು ನವೀಕರಿಸುತ್ತಿದ್ದೇವೆ. ದಯವಿಟ್ಟು ಸ್ವಲ್ಪ ಸಮಯದ ನಂತರ ಮತ್ತೆ ನೋಡಿ — ನಿಮ್ಮ ತಾಳ್ಮೆಗೆ ಧನ್ಯವಾದಗಳು.',
    catalogEmptyThanks: 'ಏಕದಂತ್ ಆರ್ಟ್ಸ್‌ಗೆ ಭೇಟಿ ನೀಡಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು.',
    catalogUpdatingTitle: 'ಇನ್ನಷ್ಟು ಮೂರ್ತಿಗಳನ್ನು ಸೇರಿಸಲಾಗುತ್ತಿದೆ',
    catalogUpdatingHint:
      'ಈಗ ಲಭ್ಯವಿರುವ ಮೂರ್ತಿಗಳನ್ನು ನೋಡಿ — ಹೊಸ ವಿನ್ಯಾಸಗಳನ್ನು ಸೇರಿಸಲಾಗುತ್ತಿದೆ. ಪೂರ್ಣ ಸಂಗ್ರಹಕ್ಕಾಗಿ ಶೀಘ್ರದಲ್ಲಿ ಮತ್ತೆ ಭೇಟಿ ನೀಡಿ.',
    collapsedHint:
      'ಮಾದರಿ ಗ್ಯಾಲರಿ ಮರೆಮಾಡಲಾಗಿದೆ. ಎಲ್ಲಾ ಲಭ್ಯವಿರುವ ಮೂರ್ತಿಗಳನ್ನು ನೋಡಲು «ನಿಮ್ಮ ಮೂರ್ತಿಯನ್ನು ಕಾಯ್ದಿರಿಸಿ» ಬಳಸಿ.',
    wholesalePriceAtCheckout: 'ವಿನಂತಿಯ ನಂತರ ಬೆಲೆ ದೃಢೀಕರಣ',
  },
  customerMode: {
    retail: 'ಚಿಲ್ಲರೆ',
    wholesale: 'ಸಗಟು',
    chooseTitle: 'ನೀವು ಚಿಲ್ಲರೆ ಅಥವಾ ಸಗಟು ಗ್ರಾಹಕರೇ?',
    changeType: 'ಗ್ರಾಹಕ ವಿಧ ಬದಲಾಯಿಸಿ',
    orderingAsRetail: 'ಚಿಲ್ಲರೆ ಆರ್ಡರ್ — ಪ್ರತಿ ಮಾದರಿಗೆ ಒಂದು ಪ್ರಮಾಣ.',
    orderingAsWholesale: 'ಸಗಟು ಆರ್ಡರ್ — ಸಗಟು ವಿನಂತಿಗೆ 14+ ಒಟ್ಟು ಪ್ರಮಾಣ ಸೇರಿಸಿ.',
    switchToWholesale: 'ಸಗಟಿಗೆ ಬದಲಾಯಿಸಿ',
    switchToRetail: 'ಚಿಲ್ಲರೆಗೆ ಬದಲಾಯಿಸಿ',
    retailHint: 'ಪ್ರತಿ ಮಾದರಿಗೆ ಒಂದು ಪ್ರಮಾಣ ಮಾತ್ರ — ಚಿಲ್ಲರೆ ಬೆಲೆ.',
    wholesaleHint: 'ಬೃಹತ್ ಪ್ರಮಾಣ — ವಿನಂತಿ ಸಲ್ಲಿಸಿ; WhatsApp ನಲ್ಲಿ ಬೆಲೆ ದೃಢೀಕರಿಸುತ್ತೇವೆ.',
    switchClearCartConfirm: 'ಗ್ರಾಹಕ ವಿಧ ಬದಲಾಯಿಸಿದರೆ ಕಾರ್ಟ್ ತೆರವಾಗುತ್ತದೆ. ಮುಂದುವರಿಯುವುದೇ?',
  },
  trustRow: {
    secureTitle: 'ಸುರಕ್ಷಿತ ಅಡ್ವಾನ್ಸ್ ಚೆಕ್‌ಔಟ್',
    secureBody: 'Razorpay ಮೂಲಕ ಸುರಕ್ಷಿತ ಪಾವತಿ ಮತ್ತು ತ್ವರಿತ ರಸೀದಿ ಡೌನ್‌ಲೋಡ್.',
    inquiryTitle: 'ಸುಲಭ ಆರ್ಡರ್ ವಿನಂತಿ',
    inquiryBody:
      'ವಿನಂತಿ ಸಲ್ಲಿಸಿ — UPI ಮುಂಗಡ ನಂತರ WhatsApp ಮೂಲಕ ದೃಢೀಕರಣ.',
    deliveryTitle: 'ನಮ್ಮ ಮನೆಯ ಕಾರ್ಯಾಗಾರಕ್ಕೆ ಭೇಟಿ ನೀಡಿ',
    deliveryBody:
      'ದಯವಿಟ್ಟು ನಮ್ಮ ಮನೆಯ ಕಾರ್ಯಾಗಾರಕ್ಕೆ ಬಂದು ಗಣೇಶ ಮೂರ್ತಿಯನ್ನು ಮನೆಗೆ ಕೊಂಡೊಯ್ಯಿರಿ. ಮನೆ ವಿತರಣೆ ಲಭ್ಯವಿಲ್ಲ. ವಿಳಾಸ: ಮನೆ ಸಂ. 283, ಮಾರುತಿ ಗಲ್ಲಿ, ಅನಗೋಲ, ಬೆಳಗಾವಿ-590006, ಕರ್ನಾಟಕ.',
    craftTitle: 'ಕೈಯಿಂದ ತಯಾರಿಸಿದ ಭರವಸೆ',
    craftBody: 'ಪ್ರತಿ ಮಾದರಿಯನ್ನು ಹಬ್ಬದ ಗುಣಮಟ್ಟ ಮತ್ತು ಪೂರ್ಣಗೊಳಿಸುವಿಕೆಗಾಗಿ ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ.',
  },
  footer: {
    companyTitle: 'ಏಕದಂತ ಆರ್ಟ್ಸ್',
    companyLead:
      'ಭಕ್ತಿ ಮತ್ತು ಕುಶಲತೆಯೊಂದಿಗೆ ತಯಾರಿಸಿದ ಸಾಂಪ್ರದಾಯಿಕ ಗಣೇಶ ಮೂರ್ತಿಗಳು. ಪ್ರಾಚೀನ ಕಲೆಯನ್ನು ಆಧುನಿಕ ಮನೆಗಳಿಗೆ ತರುವುದು.',
    companyTagline:
      'ಅತ್ಯುತ್ತಮ ಮೂರ್ತಿ ಕಲೆಯ ಮೂಲಕ ಸಾಂಸ್ಕೃತಿಕ ಪರಂಪರೆಯನ್ನು ಸಂರಕ್ಷಿಸುವ ಉತ್ಸಾಹದಿಂದ ಸ್ಥಾಪಿಸಲಾಗಿದೆ.',
    contactTitle: 'ಸಂಪರ್ಕಿಸಿ',
    infoTitle: 'ಮಾಹಿತಿ',
    adminLabel: 'ಅಡ್ಮಿನ್:',
    adminLogin: 'ಅಡ್ಮಿನ್ ಲಾಗಿನ್',
    hoursLabel: 'ವ್ಯಾಪಾರ ಸಮಯ:',
    hoursBody: 'ಸೋಮವಾರ - ಶನಿವಾರ: ಬೆಳಿಗ್ಗೆ 9 - ಸಂಜೆ 7\nಭಾನುವಾರ: ಮುಚ್ಚಲಾಗಿದೆ',
    paymentLabel: 'ಪಾವತಿ:',
    paymentBody: 'ನಗದು, UPI, ಬ್ಯಾಂಕ್ ವರ್ಗಾವಣೆ',
    deliveryLabel: 'ಕಾರ್ಯಾಗಾರ:',
    deliveryBody:
      'ನಮ್ಮ ಮನೆಯ ಕಾರ್ಯಾಗಾರಕ್ಕೆ ಭೇಟಿ ನೀಡಿ ಮೂರ್ತಿಯನ್ನು ಮನೆಗೆ ಕೊಂಡೊಯ್ಯಿರಿ. ವಿಳಾಸ: ಮನೆ ಸಂ. 283, ಮಾರುತಿ ಗಲ್ಲಿ, ಅನಗೋಲ, ಬೆಳಗಾವಿ-590006, ಕರ್ನಾಟಕ',
    address: 'ಮನೆ ಸಂ. 283, ಮಾರುತಿ ಗಲ್ಲಿ, ಅನಗೋಲ, ಬೆಳಗಾವಿ-590006, ಕರ್ನಾಟಕ',
    copyright: '© {year} ಏಕದಂತ ಆರ್ಟ್ಸ್. ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.',
    craftedWith: 'ಸಾಂಪ್ರದಾಯಿಕ ಕಲೆಗಾಗಿ ❤️ ನೊಂದಿಗೆ ತಯಾರಿಸಲಾಗಿದೆ',
    systemTag: 'ಗಣೇಶ ಮೂರ್ತಿ ಕಾಯ್ದಿರಿಸುವಿಕೆ ಮತ್ತು ನಿರ್ವಹಣಾ ವ್ಯವಸ್ಥೆ',
  },
  orderModal: {
    orderPrefix: 'ಆರ್ಡರ್',
    quantity: 'ಪ್ರಮಾಣ *',
    total: 'ಒಟ್ಟು:',
    customRequest: 'ವಿಶೇಷ ವಿನಂತಿ',
    customPlaceholder: 'ಯಾವುದೇ ವಿಶೇಷ ಅಗತ್ಯಗಳು ಅಥವಾ ವೈಯಕ್ತಿಕೀಕರಣ...',
    cartHintTitle: 'ಚೆಕ್‌ಔಟ್‌ನಲ್ಲಿ ಗ್ರಾಹಕ ವಿವರಗಳನ್ನು ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ.',
    cartHintBody: 'ನೀವು ಮೊದಲು ಕಾರ್ಟ್‌ಗೆ ಅನೇಕ ವಸ್ತುಗಳನ್ನು ಸೇರಿಸಬಹುದು.',
    addToCart: 'ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಿ 🛒',
    stockLabel: 'ಸ್ಟಾಕ್:',
    available: 'ಲಭ್ಯ',
    wholesaleMinQtyHint: 'ಸಗಟು ವಿನಂತಿಗೆ ಕಾರ್ಟ್‌ನಲ್ಲಿ ಕನಿಷ್ಠ 14 ಒಟ್ಟು ಪ್ರಮಾಣ (ಯಾವುದೇ ಮಾದರಿ ಮಿಶ್ರಣ) ಅಗತ್ಯ.',
  },
  checkoutModal: {
    title: 'ನಿಮ್ಮ ಆರ್ಡರ್ ಪೂರ್ಣಗೊಳಿಸಿ',
    summaryTitle: 'ಆರ್ಡರ್ ಸಾರಾಂಶ',
    totalAmount: 'ಒಟ್ಟು ಮೊತ್ತ:',
    customRequest: 'ವಿಶೇಷ ವಿನಂತಿ / ಬಣ್ಣ ಟಿಪ್ಪಣಿ (ಐಚ್ಛಿಕ)',
    fullName: 'ಪೂರ್ಣ ಹೆಸರು *',
    namePlaceholder: 'ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
    phone: 'ಫೋನ್ ಸಂಖ್ಯೆ *',
    phonePlaceholder: '10-ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ',
    deliveryDate: 'ಇಚ್ಛಿತ ಮನೆಗೆ ಕೊಂಡೊಯ್ಯುವ ದಿನಾಂಕ',
    advanceLabel: 'ಅಡ್ವಾನ್ಸ್ ಪಾವತಿ ಮೊತ್ತ (₹) *',
    advanceHint:
      '💰 ಒಟ್ಟು ಆರ್ಡರ್ ಮೌಲ್ಯದ ಕನಿಷ್ಠ 40% ಅಡ್ವಾನ್ಸ್ ಪಾವತಿ ಅಗತ್ಯ',
    balanceDue: 'ಅಡ್ವಾನ್ಸ್ ನಂತರ ಬಾಕಿ:',
    paymentBlurb:
      '💳 ಪಾವತಿ: ಈಗ Razorpay ಮೂಲಕ ₹{advance} ಪಾವತಿಸಿ\n🏠 ಮನೆಗೆ ಕೊಂಡೊಯ್ಯಿರಿ: ಕಾರ್ಯಾಗಾರದಿಂದ ಮೂರ್ತಿ ಕೊಂಡೊಯ್ಯುವಾಗ ಬಾಕಿ ಪಾವತಿ',
    testPaymentHint:
      'ಪರೀಕ್ಷಾ ಮೋಡ್: ಡೆಸ್ಕ್‌ಟಾಪ್‌ನಲ್ಲಿ Razorpay ನಲ್ಲಿ Test Card (4111 1111 1111 1111) ಬಳಸಿ, ಅಥವಾ Simulate ಒತ್ತಿ. ಮೊಬೈಲ್‌ನಲ್ಲಿ UPI ಅಪ್ ಅಥವಾ QR.',
    simulateTestPayment: 'ಪರೀಕ್ಷಾ ಪಾವತಿ ಅನುಕರಿಸಿ ಮತ್ತು ಆರ್ಡರ್ ಮಾಡಿ',
    proceedPayment: 'ಪಾವತಿಗೆ ಮುಂದುವರಿಯಿರಿ 💳',
    orderTypeRetail: 'ಚಿಲ್ಲರೆ ಆರ್ಡರ್',
    orderTypeWholesale: 'ಸಗಟು ಆರ್ಡರ್',
    retailOnlyWholesaleHint:
      'ನಿಮ್ಮ ಕಾರ್ಟ್‌ನಲ್ಲಿ 14+ ವಸ್ತುಗಳಿವೆ ಆದರೆ ಚಿಲ್ಲರೆ-ಮಾತ್ರ ಮಾದರಿಗಳಿದ್ದರಿಂದ ಚಿಲ್ಲರೆ ಬೆಲೆ ಅನ್ವಯಿಸುತ್ತದೆ.',
    wholesaleAdvanceHint:
      'ಸಗಟು ಆರ್ಡರ್: ಚೆಕ್‌ಔಟ್‌ನಲ್ಲಿ ಕನಿಷ್ಠ 40% ಮುಂಗಡ ಅಗತ್ಯ.',
    wholesaleInquiryHint:
      'ನಿಮ್ಮ ವಿನಂತಿಯನ್ನು ಪರಿಶೀಲಿಸಿದ ನಂತರ WhatsApp ನಲ್ಲಿ ಬೆಲೆ ಮತ್ತು ಮುಂಗಡ ದೃಢೀಕರಿಸುತ್ತೇವೆ.',
  },
  toast: {
    cartRestored: 'ನಿಮ್ಮ ಕಾರ್ಟ್ ವಸ್ತುಗಳು ಇನ್ನೂ ಇವೆ!',
    cartCleared: 'ಕಾರ್ಟ್ ತೆರವಾಗಿದೆ',
    loadCategoriesFailed: 'ವರ್ಗಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ',
    loadModelsFailed: 'ಮಾದರಿಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ',
    notEnoughStock: 'ಸಾಕಷ್ಟು ಸ್ಟಾಕ್ ಇಲ್ಲ',
    itemAdded: 'ವಸ್ತು ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಲಾಗಿದೆ! 🛒',
    itemAlreadyInCart: 'ಈ ಮಾದರಿ ಈಗಾಗಲೇ ಕಾರ್ಟ್‌ನಲ್ಲಿದೆ',
    wholesaleMinQty: 'ಸಗಟು ಚೆಕ್‌ಔಟ್‌ಗೆ ಕಾರ್ಟ್‌ನಲ್ಲಿ ಕನಿಷ್ಠ {count} ಒಟ್ಟು ಪ್ರಮಾಣ (ಯಾವುದೇ ಮಾದರಿ ಮಿಶ್ರಣ) ಅಗತ್ಯ.',
    wholesaleAddedNeedMore: 'ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಲಾಗಿದೆ — ಸಗಟು ಚೆಕ್‌ಔಟ್‌ಗೆ {count} ಒಟ್ಟು ಪ್ರಮಾಣ ತಲುಪಲು ಇನ್ನಷ್ಟು ಮಾದರಿಗಳನ್ನು ಸೇರಿಸಿ.',
    nameRequired: 'ಗ್ರಾಹಕರ ಹೆಸರು ಅಗತ್ಯ',
    phoneRequired: 'ಮಾನ್ಯ 10-ಅಂಕಿಯ ಫೋನ್ ಸಂಖ್ಯೆ ಅಗತ್ಯ',
    advanceMin: 'ಅಡ್ವಾನ್ಸ್ ಪಾವತಿ ಕನಿಷ್ಠ ₹{amount} (ಒಟ್ಟು ಆರ್ಡರ್ ಮೌಲ್ಯದ 40%)',
    advanceExceeds: 'ಅಡ್ವಾನ್ಸ್ ಮೊತ್ತ ಒಟ್ಟು ಆರ್ಡರ್ ಮೌಲ್ಯವನ್ನು ಮೀರುವಂತಿಲ್ಲ',
    cartEmpty: 'ಕಾರ್ಟ್‌ನಲ್ಲಿ ವಸ್ತುಗಳಿಲ್ಲ',
    advancePositive: 'ಪಾವತಿ ಮುಂದುವರಿಸಲು ಅಡ್ವಾನ್ಸ್ ಮೊತ್ತ ₹0 ಗಿಂತ ಹೆಚ್ಚಿರಬೇಕು',
    orderSuccessReceipt:
      '🎉 ಆರ್ಡರ್ ಯಶಸ್ವಿಯಾಗಿ ಇರಿಸಲಾಗಿದೆ! ರಸೀದಿ ಡೌನ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    needPdfReceipt: 'PDF ಬೇಕೇ?',
    downloadPdf: 'PDF ಡೌನ್‌ಲೋಡ್',
    thankYou: 'ನಿಮ್ಮ ಆರ್ಡರ್‌ಗೆ ಧನ್ಯವಾದಗಳು! ಶೀಘ್ರದಲ್ಲೇ ಸಂಪರ್ಕಿಸುತ್ತೇವೆ.',
    orderAfterPaymentFail:
      'ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ ಆದರೆ ಆರ್ಡರ್ ರಚನೆ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ.',
    paymentCancelled: 'ಪಾವತಿಯನ್ನು ಬಳಕೆದಾರರು ರದ್ದುಗೊಳಿಸಿದ್ದಾರೆ',
    paymentFailed: 'ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    paymentInitFailed: 'ಪಾವತಿ ಪ್ರಾರಂಭಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    wishlistRemoved: 'ಇಚ್ಛಾ ಪಟ್ಟಿಯಿಂದ ತೆಗೆದುಹಾಕಲಾಗಿದೆ',
  },
  orderFlow: {
    verifying: 'ನಿಮ್ಮ ಪಾವತಿಯನ್ನು ದೃಢೀಕರಿಸಲಾಗುತ್ತಿದೆ…',
    booking: 'ನಿಮ್ಮ ಗಣೇಶ ವಿಗ್ರಹವನ್ನು ಬುಕ್ ಮಾಡಲಾಗುತ್ತಿದೆ…',
    receipt: 'ನಿಮ್ಮ ರಸೀದಿ ತಯಾರಿಸಲಾಗುತ್ತಿದೆ…',
    inquirySubmitting: 'ನಿಮ್ಮ ವಿನಂತಿ ಉಳಿಸಲಾಗುತ್ತಿದೆ…',
    inquirySuccessTitle: 'ನಿಮ್ಮ ವಿನಂತಿ ಸ್ವೀಕರಿಸಲಾಗಿದೆ',
    inquirySuccessSubtitle: 'ಉಲ್ಲೇಖ: {inquiryNo}',
    inquirySuccessBody:
      'ನಿಮ್ಮ ವಿನಂತಿ ನಮ್ಮ ವ್ಯವಸ್ಥೆಯಲ್ಲಿ ಉಳಿಸಲಾಗಿದೆ. UPI ಮುಂಗಡ ನಂತರ ಆರ್ಡರ್ ದೃಢೀಕರಿಸುತ್ತೇವೆ. ವೇಗವಾದ ಫಾಲೋ-ಅಪ್‌ಗೆ WhatsApp ನಲ್ಲಿ ತಿಳಿಸಬಹುದು.',
    openWhatsApp: 'WhatsApp ನಲ್ಲಿ ತಿಳಿಸಿ',
    bookedTitle: 'ನಿಮ್ಮ ಗಣೇಶ ವಿಗ್ರಹ ಯಶಸ್ವಿಯಾಗಿ ಬುಕ್ ಆಗಿದೆ',
    bookedSubtitle: 'ಆರ್ಡರ್ {orderNo} — ರಸೀದಿ ನಿಮ್ಮ ಸಾಧನಕ್ಕೆ ಡೌನ್‌ಲೋಡ್ ಆಗಿದೆ',
    continueShopping: 'ಶಾಪಿಂಗ್ ಮುಂದುವರಿಸಿ',
    downloadPdf: 'PDF ರಸೀದಿ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
  },
  razorpay: {
    orgName: 'ಏಕದಂತ ಆರ್ಟ್ಸ್',
    orderDescription: '{count} ವಸ್ತುವಿನ ಆರ್ಡರ್',
    orderDescriptionPlural: '{count} ವಸ್ತುಗಳ ಆರ್ಡರ್',
  },
  productDetail: {
    backToShop: '← ಅಂಗಡಿಗೆ ಹಿಂತಿರುಗಿ',
    checkout: 'ಚೆಕ್‌ಔಟ್ ({count})',
    viewGallery: 'ಗ್ಯಾಲರಿ ನೋಡಿ',
    craft: 'ಕುಶಲ',
    handmade: 'ಕೈಯಿಂದ ತಯಾರಿಸಿದ',
    delivery: 'ಮನೆಗೆ ಕೊಂಡೊಯ್ಯಿರಿ',
    panIndia: 'ಕಾರ್ಯಾಗಾರದಿಂದ',
    payment: 'ಪಾವತಿ',
    secure: 'ಸುರಕ್ಷಿತ',
    inquiry: 'UPI ಮುಂಗಡ',
    stock: 'ಸ್ಟಾಕ್:',
    available: 'ಲಭ್ಯ',
    outOfStock: 'ಸ್ಟಾಕ್ ಇಲ್ಲ',
    outOfStockHint: 'ಈ ಮಾದರಿ ಪ್ರಸ್ತುತ ಲಭ್ಯವಿಲ್ಲ.',
    retailOnlyBadge: 'ಚಿಲ್ಲರೆ ಮಾತ್ರ',
    category: 'ವರ್ಗ:',
    defaultCategory: 'ಗಣೇಶ ಮೂರ್ತಿ',
    whyTitle: 'ಗ್ರಾಹಕರು ಇದನ್ನು ಏಕೆ ಆಯ್ಕೆ ಮಾಡುತ್ತಾರೆ',
    why1: '• ಮನೆ ಮತ್ತು ಕಾರ್ಯಕ್ರಮಗಳಿಗೆ ಸೂಕ್ತವಾದ ಉನ್ನತ ಕೈಯಿಂದ ತಯಾರಿಸಿದ ಪೂರ್ಣಗೊಳಿಸುವಿಕೆ.',
    why2: '• ಸುರಕ್ಷಿತ ಅಡ್ವಾನ್ಸ್ ಬುಕಿಂಗ್ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ಆರ್ಡರ್ ದೃಢೀಕರಣ.',
    why2Inquiry:
      '• ವಿನಂತಿ ನಮ್ಮ ವ್ಯವಸ್ಥೆಯಲ್ಲಿ ಉಳಿಸಲಾಗುತ್ತದೆ — WhatsApp ಮತ್ತು UPI ಮುಂಗಡ ನಂತರ ದೃಢೀಕರಣ.',
    why3: '• ಚೆಕ್‌ಔಟ್‌ಗೆ ಮೊದಲು ವೈಯಕ್ತಿಕ ವಿಶೇಷ ವಿನಂತಿ ಬೆಂಬಲ.',
    addToCart: 'ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಿ',
    buyNow: 'ಈಗ ಖರೀದಿಸಿ',
    continueToCheckout: 'ಚೆಕ್‌ಔಟ್‌ಗೆ ಮುಂದುವರಿಯಿರಿ',
    continueToInquiry: 'ವಿನಂತಿಗೆ ಮುಂದುವರಿಯಿರಿ',
    continueShopping: 'ಖರೀದಿ ಮುಂದುವರಿಸಿ',
    wholesaleBasketLink: 'ಸಗಟು ಬುಕೆಟ್ ಆರ್ಡರ್ ತಯಾರಿಸಿ',
    paymentCard: 'ಸುರಕ್ಷಿತ ಚೆಕ್‌ಔಟ್‌ನೊಂದಿಗೆ 40% ಅಡ್ವಾನ್ಸ್',
    inquiryCard: 'ವಿನಂತಿಯ ನಂತರ UPI ಮುಂಗಡದೊಂದಿಗೆ 40% ದೃಢೀಕರಣ',
    paymentCardTitle: 'ಪಾವತಿ',
    supportCard: 'ವಿಶೇಷ ವಿನಂತಿಗಳಿಗೆ ನೇರ ಸಹಾಯ',
    supportCardTitle: 'ಬೆಂಬಲ',
    relatedModels: 'ಸಂಬಂಧಿತ ಮಾದರಿಗಳು',
    testimonialsTitle: 'ಕುಟುಂಬಗಳು ಏನು ಮೆಚ್ಚುತ್ತಾರೆ',
    testimonial1:
      '"ವಿವರಗಳು ಮತ್ತು ಪೂರ್ಣಗೊಳಿಸುವಿಕೆ ಫೋಟೋಗಳಂತೆಯೇ ಕಾಣಿಸಿತು. ಕಾಯ್ದಿರಿಸುವಿಕೆ ಪ್ರಕ್ರಿಯೆ ಸುಗಮವಾಗಿತ್ತು."',
    testimonial2:
      '"ತ್ವರಿತ ದೃಢೀಕರಣ ಮತ್ತು ಪಾರದರ್ಶಕ ಅಡ್ವಾನ್ಸ್ ಪಾವತಿಯಿಂದ ವಿಶ್ವಾಸ ಹೆಚ್ಚಿತು."',
    testimonial3:
      '"ಮನೆಯ ಕಾರ್ಯಾಗಾರಕ್ಕೆ ಭೇಟಿ ನೀಡುವುದು ಸುಲಭವಾಗಿತ್ತು ಮತ್ತು ಮೂರ್ತಿಯನ್ನು ಉತ್ತಮ ಸ್ಥಿತಿಯಲ್ಲಿ ಮನೆಗೆ ಕೊಂಡೊಯ್ದೆವು."',
    loading: 'ಮಾದರಿ ವಿವರಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...',
    modelNotFound: 'ಮಾದರಿ ಕಂಡುಬಂದಿಲ್ಲ',
    loadDetailFailed: 'ಮಾದರಿ ವಿವರಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ',
    itemAdded: 'ವಸ್ತು ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಲಾಗಿದೆ',
    orderPlaced: 'ಆರ್ಡರ್ ಯಶಸ್ವಿಯಾಗಿ ಇರಿಸಲಾಗಿದೆ',
    paymentCancelled: 'ಪಾವತಿ ರದ್ದು',
    advanceAtLeast: 'ಅಡ್ವಾನ್ಸ್ ಕನಿಷ್ಠ ₹{amount} ಇರಬೇಕು',
    advanceExceedsTotal: 'ಅಡ್ವಾನ್ಸ್ ಒಟ್ಟು ಮೊತ್ತವನ್ನು ಮೀರುವಂತಿಲ್ಲ',
    proceedPayment: 'ಪಾವತಿಗೆ ಮುಂದುವರಿಯಿರಿ',
    submitInquiry: 'ವಿನಂತಿ ಸಲ್ಲಿಸಿ ಮತ್ತು WhatsApp ನಲ್ಲಿ ತಿಳಿಸಿ',
    inquiryBlurb:
      'ನಿಮ್ಮ ವಿನಂತಿ ನಮ್ಮ ವ್ಯವಸ್ಥೆಯಲ್ಲಿ ಉಳಿಸಲಾಗುತ್ತದೆ. WhatsApp ತೆರೆಯುತ್ತದೆ — UPI ಮುಂಗಡ ನಂತರ ದೃಢೀಕರಿಸುತ್ತೇವೆ.',
    paymentDisabledHint: 'ಆನ್‌ಲೈನ್ ಪಾವತಿ ಲಭ್ಯವಿಲ್ಲ. ವಿನಂತಿ ಸಲ್ಲಿಸಿ — ಮುಂಗಡ ನಂತರ ದೃಢೀಕರಣ.',
    completeOrder: 'ನಿಮ್ಮ ಆರ್ಡರ್ ಪೂರ್ಣಗೊಳಿಸಿ',
    orderSummary: 'ಆರ್ಡರ್ ಸಾರಾಂಶ',
    totalAmount: 'ಒಟ್ಟು ಮೊತ್ತ:',
    verifyFailed: 'ಪಾವತಿ ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ',
  },
};

function deepMerge(base, override) {
  const out = { ...base };
  for (const k of Object.keys(override)) {
    if (override[k] && typeof override[k] === 'object' && !Array.isArray(override[k])) {
      out[k] = deepMerge(base[k] || {}, override[k]);
    } else {
      out[k] = override[k];
    }
  }
  return out;
}

/** Ensure locale maps fall back to EN for any missing leaf strings */
export const STRINGS = {
  en,
  mr: deepMerge(en, mr),
  kn: deepMerge(en, kn),
};

export function collageLabelKey(imageId) {
  const map = {
    'devotion-1': 'collage.labelSacredDetail',
    'devotion-2': 'collage.labelArtisanTouch',
    'devotion-3': 'collage.labelFestiveGlow',
    'devotion-4': 'collage.labelGracefulForm',
  };
  return map[imageId] || 'collage.labelSacredDetail';
}
